import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

import { ReportsApi } from '../../../api/reports-api';
import { ReportHelper } from '../../report-helper';

@Component({
    selector: 'om-basic-bridge-report',
    templateUrl: './basicBridgeReport.html',
    styleUrls: ['../../reports.css', './basicBridgeReport.css']
})

export class BasicBridgeReportComponent implements OnInit {
    private bridgeId: any;
    reportData: any;
    error = false;
    errorMessage = this.reportHelper.reportErrorMessages.noReportData;
    isGenerating = false;

    constructor(private readonly reportsApi: ReportsApi,
                private readonly reportHelper: ReportHelper,
                private readonly route: ActivatedRoute,
                titleService: Title) {
        titleService.setTitle(titleService.getTitle() + ' : Basic Bridge Report');
    }

    async ngOnInit() {
        this.isGenerating = true;
        this.route.paramMap.subscribe(x => {
            this.bridgeId = JSON.parse(window.localStorage.getItem(x.get('id'))).bridgeId;
            this.loadReport();
        });
    }

    loadReport() {
        this.isGenerating = true;
        return this.reportsApi.getBridgeBasicReportData(parseInt(this.bridgeId, 10)).then((reportData) => {
            this.reportData = reportData;
            this.isGenerating = false;
        }, (error) => {
            this.isGenerating = false;
            this.error = true;
        });
    }
}
